import $ from "jquery";
import moment from "moment";
import "bootstrap-sass";
import Seed from "DMS/Seed/All";
import { notify } from "DMS/Utils/modal";
import getGeolocParamsAndFilters from "DMS/Utils/GoogleMapFilters";
import * as GoogleMapStarter from "DMS/Utils/GoogleMapStarter";
import { refreshList } from "DMS/Controllers/listController";
export function initializeCtrl() {
    // DMSOrigin n'est pas défini pour la geoloc dans le planning
    if (typeof DMSOrigin !== 'undefined') {
        GoogleMapStarter.strategyGoogleMap(DMSOrigin);
    }
    if ($("#geoloc-body").length > 0)
        Seed.Tab.AddTab();
}
export function changeImage(button) {
    var iconElement = button.children[0];
    var buttonClass = button.children[0].className;
    if (buttonClass === 'fa fa-plus') {
        iconElement.className = 'fa fa-minus';
    }
    else if (buttonClass === 'fa fa-minus') {
        iconElement.className = 'fa fa-plus';
    }
}
export function changeActiveButton(button) {
    if (!button.className.match('active')) {
        $(button).siblings().each(function () {
            if (this.className.match('active')) {
                this.classList.remove('active');
            }
        });
        button.classList.add('active');
    }
}
// renvoie true si le type de geolocalisation n'est pas 'tour'
function getLocationType() {
    let locationType = '';
    Seed.Tab.GetFrame().find('#location-type').children().each(function () {
        let $this = $(this);
        if ($this.hasClass('active')) {
            locationType = $this.data('geoloctype');
        }
    });
    return (locationType === 'position' || locationType === 'depart' || locationType === 'arrivee') ? true : false;
}
function focusTourButton() {
    Seed.Tab.GetFrame().find('#location-type').children().each(function () {
        if (this.className.match('active')) {
            this.classList.remove('active');
        }
    });
    document.querySelectorAll('[data-geoloctype="tour"]')[0].classList.add('active');
}
function focusRoadButton() {
    Seed.Tab.GetFrame().find('#tour-mode').children().each(function () {
        if (this.className.match('active')) {
            this.classList.remove('active');
        }
    });
    document.querySelectorAll('[data-geoloctype="road"]')[0].classList.add('active');
}
export function removeInfoPanel() {
    return new Promise(function (resolve) {
        let topPanel = document.getElementById('span-for-data');
        let optionsPanel = document.getElementById('colForOptions');
        let infoPanel = document.getElementById('information_panel');
        if (topPanel !== null) {
            topPanel.innerHTML = '';
        }
        if (infoPanel !== null && optionsPanel !== null) {
            optionsPanel.removeChild(infoPanel);
        }
        resolve();
    });
}
/* ! variables globales ! : posstart, posarrrival, fileNumber */
export function getPanelForTechOrFileAddressData(data, context = 'position') {
    let panel_html = '';
    let title_str = '';
    let body_html = '<p>' + data['address'] + '</p>';
    switch (context) {
        case 'position':
            title_str = data['bbmindex'] + ' - ' + data['codetechnicien'] + ' : ' + data['nomtechnicien'];
            body_html += '<p>' + data['last_actu_string'] + ' : '
                + (data['last_actu_value'] ? moment(data['last_actu_value']).format('LLLL') : '')
                + '</p><p>' + data['arret_actu_string'] + ' : '
                + (data['arret_actu_value'] ? moment(data['arret_actu_value']).format('LLLL') : '')
                + '</p>';
            break;
        case 'depart':
            title_str = posstart;
            break;
        case 'arrivee':
            title_str = posarrival;
            break;
        case 'both':
            title_str = posstart + ' - ' + posarrival;
            break;
        case 'file':
            title_str = data['numdossier'] != '' ? fileNumber + data['numdossier'] : '';
            // dates et heures debut et fin intervention
            body_html = '<p>' + data['nomclientlivraison'] + '</p>'
                + body_html
                + '<p>' + data['datedebut_string'] + ' : '
                + (data['datedebut_value'] ? moment(data['datedebut_value']).format('LLLL') : '')
                + '</p><p>' + data['datefin_string'] + ' : '
                + (data['datefin_value'] ? moment(data['datefin_value']).format('LLLL') : '')
                + '</p>';
            break;
    }
    panel_html = '<div class="panel panel-primary"><div class="panel-heading">'
        + '<p>' + title_str + '</p></div>'
        + '<div class="panel-body">'
        + body_html
        + '</div></div>';
    return panel_html;
}
export function showTechData(button) {
    return new Promise(function (resolve, reject) {
        let techId = $(button).parent().siblings()[1].childNodes[0];
        if (marker[techId.nodeValue] !== undefined) {
            new google.maps.event.trigger(marker[techId.nodeValue], 'click');
            window.map.setCenter(marker[techId.nodeValue].getPosition());
            resolve();
        }
        else {
            notify(noData);
            resolve();
        }
    });
}
export function showTechTour(button) {
    let $panel = $(button).closest('.panel.panel-primary');
    let techBbmindex = $panel.children('.panel-heading').children('.row')[0].children['bbmindex'].textContent;
    focusTourButton();
    let chosenDate = $('.input-group-addon.SM-datepicker').val();
    clearMarkers();
    GoogleMapStarter.strategyGoogleMap('tour', { 'date': chosenDate, 'bbmindex': techBbmindex });
}
export function refreshAllGeoloc(hasToRefreshList = true) {
    var paramsAndFilters = getGeolocParamsAndFilters();
    paramsAndFilters.then(function (values) {
        // Before refresh list, make sure I made an ajax call to strategyIndex giving right properties. (based on values.location-type)
        removeInfoPanel();
        clearMarkers();
        // values[ 'location-type' ] = 'position' ou 'depart' ou 'arrivee'
        // values[ 'filters' ] de type :
        // { secteur: { value: "",
        //              "table-to-join": "xsecteur",
        //              operator: "eq" },
        //   nomtechnicien: { value: "",
        //                    "table-to-join": "xtechnicien",
        //                    operator: "contains" },
        //   competence: { value: "",
        //                 "table-to-join": "techniciencompetence",
        //                 operator: "eq" } }
        GoogleMapStarter.strategyGoogleMap(values['location-type'], values['filters']);
        if (hasToRefreshList) {
            refreshList();
        }
        changeMapWidth().then(recenterMap);
    });
}
export function clearMarkers(isPlanning) {
    if (typeof marker !== 'undefined') {
        for (let test in marker) {
            if (typeof marker[test] !== 'undefined' && marker[test] !== null) {
                marker[test].setMap(null);
            }
        }
        marker = [];
    }
    if (typeof directionsDisplay !== 'undefined') {
        directionsDisplay.setMap(null);
    }
    if (typeof window.flightPath !== 'undefined') {
        window.flightPath.setMap(null);
        window.flightPath = undefined;
        if (typeof isPlanning === 'undefined' || !isPlanning) {
            focusRoadButton();
        }
        else {
            $(".btnFlyPath").addClass("btn-default").removeClass("btn-primary active");
            window.displayTraffic = false;
        }
    }
}
export function toggleTraffic(hasToBeDisplayed) {
    if (typeof trafficLayer === 'undefined')
        trafficLayer = new google.maps.TrafficLayer();
    if (hasToBeDisplayed)
        trafficLayer.setMap(map);
    else
        trafficLayer.setMap(null);
}
export async function toggleFlyPath(doIt, isPlanning) {
    let output = true;
    if (!getLocationType() && doIt && typeof window.flightPath === 'undefined') {
        let flyPathCoord = [];
        let startLat = typeof marker.depart !== 'undefined' ? marker.depart.getPosition().lat() : marker.both.getPosition().lat();
        let startLng = typeof marker.depart !== 'undefined' ? marker.depart.getPosition().lng() : marker.both.getPosition().lng();
        flyPathCoord.push(new google.maps.LatLng(startLat, startLng));
        for (let mark in marker) {
            if (mark.startsWith('file')) {
                flyPathCoord.push(new google.maps.LatLng(marker[mark].getPosition().lat(), marker[mark].getPosition().lng()));
            }
        }
        let endLat = typeof marker.arrivee !== 'undefined' ? marker.arrivee.getPosition().lat() : marker.both.getPosition().lat();
        let endLng = typeof marker.arrivee !== 'undefined' ? marker.arrivee.getPosition().lng() : marker.both.getPosition().lng();
        flyPathCoord.push(new google.maps.LatLng(endLat, endLng));
        window.flightPath = new google.maps.Polyline({
            path: flyPathCoord,
            strokeColor: "#0288d1",
            strokeOpacity: 0.5,
            strokeWeight: 3
        });
        window.flightPath.setMap(map);
        if (typeof directionsDisplay !== 'undefined') {
            directionsDisplay.setMap(null);
        }
    }
    else if (!getLocationType() && doIt && typeof window.flightPath !== 'undefined') {
        notify(alreadyDisplayed);
    }
    else if (!getLocationType() && !doIt) {
        if (typeof window.flightPath !== 'undefined') {
            window.flightPath.setMap(null);
            window.flightPath = undefined;
        }
        if (typeof directionsDisplay !== 'undefined') {
            directionsDisplay.setMap(map);
        }
    }
    else if (typeof isPlanning === 'undefined' || !isPlanning) {
        focusRoadMode(event.currentTarget).then(notify(notRightDisplayMode));
        output = false;
    }
    return output;
}
function focusRoadMode(flyPathButton) {
    return new Promise(function (resolve) {
        let toFocus;
        if (flyPathButton.tagName === 'I') {
            toFocus = flyPathButton.parentElement;
            $(toFocus).removeClass('active');
            $(toFocus).siblings().addClass('active');
        }
        else if (flyPathButton.tagName === 'BUTTON') {
            $(flyPathButton).removeClass('active');
            $(flyPathButton).siblings().addClass('active');
        }
        resolve();
    });
}
// change la largeur de la carte en fonction du type de geolocalisation : 
// 
// pour distinguer le conteneur googleMap créé dans un nouvel onglet
// pour la géolocalisation "pure" du conteneur googleMap créé dans le planning
// ce dernier dispose de l'attribut data-container="planning"
//
// window.panelContext = true indique, quand on n'est pas en mode tournée
// que le panneau listant les techniciens est affiché
// (GoogleMapInfoPanel.js : createInformationPanelContainer)
// (l'affichage de ce panneau se fait en cliquant sur le 'marker'
// qui indique une même position pour plusieurs techniciens)
// (listener dans : GoogleMapStarter.js : setUpCustomMarker)
//
export async function changeMapWidth() {
    let gmap = $('.googleMap[data-tab]')[0];
    // getLocationType renvoie true si le type est 'position', 'depart' ou 'arrivee'
    let isNotTour = getLocationType();
    // on n'est pas en mode tournée et le panneau listant les techniciens
    // n'est plus affiché => retour à la taille initiale de la carte = 100%
    if (gmap.style.width === '70%' && isNotTour && window.panelContext === false) {
        gmap.style.width = '100%';
    }
    // on n'est pas en mode tournée et le panneau listant les techniciens
    // est affiché => on affiche la carte à 70% pour laisser la place au panneau
    // ou
    // redimensionnement de la carte en mode tournée si on n'est pas dans le planning
    // pour laisser la place à droite pour la liste des interventions de la tournée
    else if (((gmap.style.width === '100%' || gmap.style.width === '') && isNotTour && window.panelContext === true)
        || (gmap.getAttribute('data-container') != 'planning' && !isNotTour)) {
        gmap.style.width = '70%';
    }
    window.panelContext = false;
}
export async function recenterMap() {
    bounds = new google.maps.LatLngBounds();
    google.maps.event.trigger(map, "resize"); // @todo : passer une référence ?
    if (typeof marker !== 'undefined') {
        for (let markerId in marker) {
            if (!/[_]+/.test(markerId) && typeof marker[markerId].position !== 'undefined') {
                bounds.extend(new google.maps.LatLng(marker[markerId].position.lat(), marker[markerId].position.lng()));
            }
            else if (typeof marker[markerId]['latitude'] !== 'undefined' && typeof marker[markerId]['longitude'] !== 'undefined') {
                bounds.extend(new google.maps.LatLng(marker[markerId]['latitude'], marker[markerId]['longitude']));
            }
            // custom markers ('depart', 'arrivee' ou 'both')
            else if (typeof marker[markerId]['latlng_'] !== 'undefined') {
                bounds.extend(new google.maps.LatLng(marker[markerId]['latlng_'].lat(), marker[markerId]['latlng_'].lng()));
            }
        }
        window.map.fitBounds(bounds);
        if (window.map.getZoom() >= 16) {
            window.map.setZoom(15);
        }
    }
}
export function formatTime(time) {
    let tempMinutes = time % 3600;
    let hours = (time - tempMinutes) / 3600;
    let minutes = Math.trunc(tempMinutes / 60, 0);
    return (hours > 0 ? hours + 'h&nbsp' : '') + minutes + 'min';
}
//# sourceMappingURL=geolocController.js.map